export const navItems = [
    { text: 'About Us', link: '/about-us' },
    { text: 'FAQ', link: '/faq' },
    { text: 'Blog', link: '/blog' },
    { text: 'Contact Us', link: '/contact' },
    { text: 'Privacy Policy', link: '/privacy' },
    { text: 'Terms & Conditions', link: '/terms' },
    { text: 'Home', link: '/', active: true },
];